module.exports = __webpack_public_path__ + "static/media/logo.2b0dc5e5.svg";